import { AppDialog } from "@/components/ui/AppDialog";
import { BodyText, CaptionText } from "@/components/ui/Typography";
import { BRAND_COLORS as C } from "@/lib/brandColors";
import React from "react";
import { Pressable, StyleSheet } from "react-native";
import { XStack } from "tamagui";

type ConfirmSignOutDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  busy?: boolean;
};

/** Same shell as bookmark delete confirm — Cancel + Sign out. */
export function ConfirmSignOutDialog({
  open,
  onOpenChange,
  onConfirm,
  busy = false,
}: ConfirmSignOutDialogProps) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Sign out"
      maxWidth={400}
      instanceKey="sign-out-confirm"
    >
      <BodyText color={C.muted} ta="left">
        Are you sure you want to sign out?
      </BodyText>
      <XStack gap={12} width="100%">
        <Pressable
          onPress={() => onOpenChange(false)}
          disabled={busy}
          style={[styles.secondaryBtn, busy && styles.btnDisabled]}
          accessibilityRole="button"
        >
          <CaptionText color={C.text} fontWeight="600">
            Cancel
          </CaptionText>
        </Pressable>
        <Pressable
          onPress={onConfirm}
          disabled={busy}
          style={[styles.dangerBtn, busy && styles.btnDisabled]}
          accessibilityRole="button"
        >
          <CaptionText color={C.cardBg} fontWeight="600">
            Sign out
          </CaptionText>
        </Pressable>
      </XStack>
    </AppDialog>
  );
}

const styles = StyleSheet.create({
  secondaryBtn: {
    flex: 1,
    backgroundColor: C.pageBg,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 999,
    alignItems: "center",
  },
  dangerBtn: {
    flex: 1,
    backgroundColor: C.error,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 999,
    alignItems: "center",
  },
  btnDisabled: {
    opacity: 0.5,
  },
});
